const draaikiepraamReparatie = {
  seo: {
    title: "Draaikiepraam Reparatie Eindhoven | 48u Service",
    description:
      "Draaikiepraam niet meer sluiten of klem ? Wij repareren en stellen draaikiepramen af in Eindhoven. 48u-spoedservice, vaste prijs vanaf €75, 10 jaar garantie.",
  },
  breadcrumb: {
    home: "Home",
    diensten: "Diensten",
    current: "Draaikiepraam reparatie",
  },
  hero: {
    pill: "DIENST — DRAAIKIEPRAAM REPARATIE",
    h1: "Draaikiepraam reparatie in Eindhoven",
    subhead:
      "Sluit uw draaikiepraam niet meer goed, klemt het mechanisme of zit er tocht langs het kozijn? Onze monteurs repareren en stellen alle merken af en vervangen versleten nokken.",
    usps: [
      "Vanaf €75 per raam",
      "Klaar in 30-45 minuten",
      "Alle merken (Roto, Winkhaus, Maco, Sobinco)",
    ],
    ctaPhone: "040 798 7470",
    ctaOfferte: "Gratis offerte",
  },
  intro: {
    h2: "Hoe werkt een draaikiepraam reparatie?",
    p1:
      "Een draaikiepraam reparatie is vaak sneller en goedkoper dan u denkt. Het raam heeft twee standen: draaien (zijwaarts openen) en kiepen (kantelen voor ventilatie). Door dagelijks gebruik en uitzetting van het kozijn raakt het beslag na 5 tot 10 jaar uit afstelling. Wij bieden complete draaikiepraam reparatie inclusief afstelling, smering en vervanging van versleten nokken.",
    p2:
      "U merkt slijtage aan tocht, een raam dat moeilijk sluit, of een kruk die zwaar draait. Een kiep raam reparatie of kantelraam reparatie is meestal binnen 30 tot 45 minuten uitgevoerd. Het is een normale slijtage, geen kapot kozijn. Zelfs als uw draaikiepraam niet meer dicht wil of helemaal klem zit, lossen wij dat op zonder het hele raam te vervangen.",
    p3:
      "In de meeste gevallen is reparatie voldoende en hoeft u niet te kiezen voor een dure draaikiepraam vervangen. Onze monteurs lossen klemmende mechanismen, scheef hangende ramen en slecht sluitende kozijnen op in één bezoek. Alleen bij ernstige profielbeschadiging adviseren wij vervanging — en dan geven wij eerlijk advies zonder verplichting.",
    p4:
      "ISDE-subsidie 2026 : vervangt u enkel glas of een verouderd kozijn door energiezuinige HR++ beglazing, dan komt u mogelijk in aanmerking voor de ISDE-subsidie. In 2026 kan dit oplopen tot duizenden euro's. Wij adviseren u gratis over de mogelijkheden en helpen bij de aanvraag.",
  },
  symptomen: {
    h2: "Wanneer is draaikiepraam reparatie nodig ?",
    rows: [
      {
        title: "Raam sluit niet meer goed",
        desc: "Sluitdruk afstellen, vaak in een kwartier opgelost.",
      },
      {
        title: "Tocht langs het kozijn",
        desc: "Nokken bijdraaien voor betere afdichting van het rubber.",
      },
      {
        title: "Mechanisme klemt of loopt stroef",
        desc: "Reinigen, smeren en bijstellen van het schaarwerk.",
      },
      {
        title: "Raam zakt scheef bij openen",
        desc: "Schaarmechanisme bijstellen of vervangen.",
      },
      {
        title: "Raamkruk draait zwaar",
        desc: "Centrale sturing nakijken en bijstellen.",
      },
      {
        title: "Nokken vertonen slijtage",
        desc: "Vervangen door originele onderdelen, vanaf €25 per stuk.",
      },
    ],
  },
  merken: {
    h2: "Wij werken met alle merken",
    items: [
      {
        title: "ROTO",
        desc: "NT, NX, Frank — alle generaties",
      },
      {
        title: "WINKHAUS",
        desc: "activPilot, autoLock, comfortDrive",
      },
      {
        title: "MACO",
        desc: "Multi-Matic, Z-TA, RUSTICO",
      },
      {
        title: "SOBINCO",
        desc: "Alle profielsystemen",
      },
    ],
    note: "Ook GU, Siegenia en oudere systemen uit de jaren '80 en '90. Twijfelt u over het merk? Onze monteurs herkennen het ter plaatse.",
  },
  werkwijze: {
    h2: "Onze werkwijze bij draaikiepraam reparatie",
    steps: [
      {
        nr: "01",
        title: "Inspectie",
        desc: "Controle van beslag, nokken en sluitstukken",
      },
      {
        nr: "02",
        title: "Reiniging",
        desc: "Vuil verwijderen en mechanisme smeren",
      },
      {
        nr: "03",
        title: "Afstelling",
        desc: "Sluitdruk, hoogte en sluitstukken bijstellen",
      },
      {
        nr: "04",
        title: "Test + garantie",
        desc: "Open/dicht-cyclus testen + 10 jaar garantie",
      },
    ],
  },
  prijzen: {
    h2: "Prijzen draaikiepraam reparatie",
    rows: [
      { dienst: "Diagnose + offerte", prijs: "Gratis", tijd: "15 min" },
      { dienst: "Reparatie + afstelling per raam", prijs: "€75", tijd: "30-45 min" },
      { dienst: "Reiniging + smering", prijs: "Inbegrepen", tijd: "-" },
      { dienst: "Nokken vervangen (per stuk)", prijs: "€25", tijd: "-" },
      { dienst: "Sluitstukken vervangen (per stuk)", prijs: "€35", tijd: "-" },
      { dienst: "Volledig beslag vervangen", prijs: "€185", tijd: "1-2u" },
    ],
    note: "Excl. 21% BTW. Bij meerdere ramen: staffelkorting vanaf 3 stuks.",
  },
  waarom: {
    h2: "Waarom kiezen voor Ramen Repair Eindhoven?",
    reasons: [
      {
        nr: "01",
        title: "Specialisten in draaikiepbeslag",
        desc: "Dagelijks werk",
      },
      {
        nr: "02",
        title: "Originele nokken op voorraad",
        desc: "Vaak in 1 bezoek klaar",
      },
      {
        nr: "03",
        title: "Snelle interventie",
        desc: "30-45 min per raam",
      },
      {
        nr: "04",
        title: "10 jaar schriftelijke garantie",
        desc: "Op werken en onderdelen",
      },
    ],
  },
  faq: {
    h2: "Veelgestelde vragen",
    items: [
      {
        q: "Kan ik een draaikiepraam zelf repareren?",
        a:
          "In theorie kunt u zelf kleine afstellingen doen, maar een volledige draaikiepraam reparatie is lastiger dan het lijkt. Elke fabrikant heeft een eigen afstelsysteem en u riskeert het mechanisme te beschadigen. Onze monteurs weten precies hoe elk merk werkt en voeren de reparatie correct uit.",
      },
      {
        q: "Hoe vaak moet een draaikiepraam worden gerepareerd?",
        a:
          "Gemiddeld elke 5 tot 10 jaar, afhankelijk van gebruik en materiaal (hout zet meer uit dan PVC). Bij tocht of een slecht sluitend raam is reparatie direct aan te raden — het voorkomt grotere problemen zoals een klemzittend raam of waterschade.",
      },
      {
        q: "Mijn houten draaikiepraam klemt. Is reparatie mogelijk?",
        a:
          "Ja, houten kozijnen zetten meer uit bij vocht en temperatuurwisselingen. Onze monteurs stellen sluitdruk en nokken af en voeren een volledige kantelraam reparatie uit. Bij houtrot verwijzen wij u door naar een timmerman, maar het beslag herstellen wij wel.",
      },
      {
        q: "Wat kost een draaikiepraam reparatie in Eindhoven ?",
        a:
          "De kosten voor een draaikiepraam reparatie in Eindhoven starten vanaf €75 per raam. Dit omvat diagnose, afstelling, reiniging en smering. Nokken vervangen kost €25 per stuk. Bij meerdere ramen ontvangt u staffelkorting. Wij geven altijd een vaste prijsopgave vooraf, zonder verborgen kosten.",
      },
      {
        q: "Hoe snel kan een draaikiepraam reparatie ?",
        a:
          "In de meeste gevallen voeren wij de draaikiepraam reparatie binnen 24 tot 48 uur uit. Spoedgevallen, zoals een draaikiepraam die klem zit of niet meer dicht kan na inbraak, behandelen wij binnen enkele uren. Bel 040 798 7470 voor directe planning.",
      },
      {
        q: "Kunnen jullie ook oude systemen uit de jaren '80 en '90 repareren?",
        a:
          "Zeker. Wij hebben veel ervaring met oudere Roto, Siegenia en Winkhaus-systemen. Als originele onderdelen niet meer leverbaar zijn, hebben wij vaak compatibele vervangers op voorraad. Een draaikiepraam vervangen is zelden nodig.",
      },
      {
        q: "Werken jullie ook in appartementen op hoogte?",
        a:
          "Ja, wij komen in alle appartementencomplexen in Eindhoven. Indien nodig nemen wij onze eigen ladder mee. Voor werk op grote hoogte (6e verdieping en hoger) werken wij samen met een steigerverhuurder.",
      },
      {
        q: "Wat kost het vervangen van nokken?",
        a:
          "Vanaf €25 per stuk, exclusief BTW. Voor een standaard raam met 4 nokken is dat €100. In combinatie met reparatie (€75) bent u vaak goedkoper uit dan bij aparte afspraken.",
      },
    ],
  },
  links: {
    h2: "Gerelateerde diensten",
    cards: [
      {
        title: "Kozijnreparatie",
        desc: "Sluitmechanisme, beslag, scharnieren en rubbers voor alle materialen.",
        href: "/kozijn-reparatie/",
      },
      {
        title: "Raamkruk vervangen",
        desc: "Nieuwe raamkrukken direct gemonteerd in alle kleuren en merken.",
        href: "/raamkruk-vervangen/",
      },
      {
        title: "Schuifpui reparatie",
        desc: "Rollers, rails en sluitwerk herstellen voor een soepele schuifpui.",
        href: "/schuifpui-reparatie/",
      },
    ],
  },
  ctaBanner: {
    h2: "Draaikiepraam reparatie in Eindhoven?",
    cta: "040 798 7470",
  },
  offerte: {
    h2: "Vraag een gratis offerte aan",
    intro:
      "Vertel ons kort wat er aan de hand is — wij nemen binnen enkele uren contact met u op met een eerlijk advies en, indien gewenst, een vrijblijvende offerte.",
    steps: ["Probleem", "Materiaal", "Gegevens"],
    step1: {
      label: "Wat is het probleem?",
      options: [
        "Raam sluit niet goed",
        "Tocht langs het kozijn",
        "Mechanisme klemt",
        "Raam zakt scheef",
        "Raamkruk draait zwaar",
        "Nokken slijtage",
        "Anders",
      ],
    },
    step2: {
      label: "Wat voor materiaal?",
      options: ["PVC / kunststof", "Aluminium", "Hout", "Weet niet"],
    },
    step3: {
      firstName: "Voornaam",
      lastName: "Achternaam",
      phone: "Telefoon",
      email: "E-mail",
      address: "Adres",
      message: "Bericht (optioneel)",
      messagePlaceholder: "Beschrijf uw draaikiepraamprobleem...",
      back: "Terug",
      next: "Volgende stap",
      submit: "Offerte aanvragen",
    },
  },
};

export default draaikiepraamReparatie;